import { MuiHidden, MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { CardResultProps } from './Card.interface';
import useStyles from './Card.styles';

const CardSkeleton = ({
  theme,
  cardColor,
  animated = true,
}: PropsWithChildren<Partial<CardResultProps>>) => {
  const classes = useStyles({});
  const rootClassName = clsx(
    classes.root,
    classes.rootSkeleton,
    animated && 'animated',
    `${theme}-theme`,
    `bg-color-${cardColor}`,
  );

  return (
    <div className={rootClassName} data-testid="qa-card-component">
      <article className={classes.cardContent}>
        <div className={classes.image}>
          <div className={clsx(classes.skeleton, 'skeleton', 'is-image')} />
        </div>
        <div className={classes.content}>
          <header>
            <div className={classes.header}>
              <MuiHidden implementation="css" smUp>
                <div className={classes.spacer} />
                <MuiTypography variant="caption" component="span">
                  <div className={clsx(classes.skeleton, 'skeleton')} />
                </MuiTypography>
              </MuiHidden>
            </div>
            <MuiTypography variant="h5" className={classes.title}>
              <div className={clsx(classes.skeleton, 'skeleton')} />
            </MuiTypography>
          </header>
          <main>
            <div className={classes.description}>
              <div className={clsx(classes.skeleton, 'skeleton')} />
              <div className={clsx(classes.skeleton, 'skeleton')} />
              <div className={clsx(classes.skeleton, 'skeleton')} />
            </div>
          </main>
          <div className={classes.spacer} />
          <footer className={classes.footer}>
            <div className={classes.tagsWrapper}>
              <MuiTypography variant="overline" component="span" className="title">
                <div className={clsx(classes.skeleton, 'skeleton')} />
              </MuiTypography>
            </div>
            <MuiHidden implementation="css" smDown>
              <div className={classes.date}>
                <div className={clsx(classes.skeleton, 'skeleton')} />
              </div>
            </MuiHidden>
          </footer>
        </div>
      </article>
    </div>
  );
};

export default CardSkeleton;
